import { OrderSteps } from "@/types/orderSteps.js";

export default {
  computed: {
    isCreatingOrder() {
      return Object.values(OrderSteps).includes(this.$route.name);
    },
  },
};
